import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section`
  box-shadow: 0 0 5px 0 rgba(${ColorPalette.RGB.PineTree}, 0.15);
  -moz-box-shadow: 0 0 5px 0 rgba(${ColorPalette.RGB.PineTree}, 0.15);
  -webkit-box-shadow: 0 0 5px 0 rgba(${ColorPalette.RGB.PineTree}, 0.15);
  margin-top: 10px;
  border-radius: 8px;
  padding: 12px 16px;
  background-color: ${ColorPalette.HEX.White};
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-direction: row;

  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 0;
    margin-left: 1px;
    margin-right: 1px;
  }

  &.no-border {
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    background-color: ${ColorPalette.Transparent};
    padding: 12px;
    border-bottom: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
    border-radius: 0;
    margin-top: 0;
  }
`;

export const Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
`;

export const Content = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-direction: row;
`;

export const NameArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

interface NameProps {
  $active: boolean;
}

export const Name = styled.h5<NameProps>`
  color: ${({ theme }) => theme.filtersBottomSheet.color};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : 'normal')};
`;

export const UpperContainer = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-direction: row;
`;

export const TextCollumn = styled.div`
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  outline: none;
  -webkit-tap-highlight-color: transparent;
`;

export const TextDescription = styled.p`
  color: ${({ theme }) => theme.filtersBottomSheet.color};
  font-size: 12px;
`;

export const TextDescriptionStrong = styled.span`
  color: ${({ theme }) => theme.filtersBottomSheet.color};
  font-size: 12px;
  font-weight: bold;
`;

export const ImgCollumn = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-direction: column;
  height: 120px;
  position: relative;
`;

export const ImgCheck = styled.img`
  width: 83px;
  margin-top: -10px;
  margin-right: -16px;
`;

export const ActionContainer = styled.div`
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  height: 35px;
  padding-right: 16px;
`;

export const ActionButton = styled.button`
  border-radius: 12px;
  border: solid 2px ${({ theme }) => theme.button.background};
  background: ${({ theme }) => theme.button.background};
  color: ${({ theme }) => theme.button.color};
  margin-top: 10px;
  margin-right: -10px;
  width: 100%;
  height: 50px;
  font-size: 15px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.53;
  letter-spacing: -0.1px;
  text-align: center;
  cursor: pointer;
`;
